var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "container",
      attrs: { "data-title": "阅伴教师端App下载" }
    },
    [
      _c("div", { staticClass: "container-content" }, [
        _c("img", {
          staticClass: "bg",
          attrs: {
            src: require("../../assets/download/teacher-download-bg.png")
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container-download ripple",
            on: { click: _vm.onDownLoad }
          },
          [_vm._v("点 击 立 即 下 载 教 师 端")]
        )
      ]),
      _vm._v(" "),
      _vm.isShowGuide
        ? _c("div", { staticClass: "container-guide" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/download/download-guide.png")
              }
            })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1d3d1a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1d3d1a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/download/DownloadTeacher.vue
// module id = null
// module chunks = 